import { render } from "./PianoKey.vue?vue&type=template&id=bafce364&scoped=true&ts=true"
import script from "./PianoKey.vue?vue&type=script&lang=ts"
export * from "./PianoKey.vue?vue&type=script&lang=ts"

import "./PianoKey.vue?vue&type=style&index=0&id=bafce364&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafce364"]])

export default __exports__